<template>
  <div class="all-vendors">
    <AtomsFormsTextInput type="search" v-model="searchText" :placeholder="i18n.t('Napište značku, kterou hledáte')" ref="searchTextbox" class="w-full max-w-[600px]" />

    <div class="my-8">
      <button v-for="letter in utils.removeDuplicatesFromArray(allVendors.map(vendor => vendor.name[0]))" class="all-vendors__letter" :class="{ 'all-vendors__letter--selected': searchFirstLetter === letter }" @click="letterToggle(letter)">{{ letter }}</button>
    </div>

    <OrganismsListsVendorList :vendors="filteredVendors" />
  </div>
</template>
<script setup>

import { useDebounceFn } from '@vueuse/core'

const i18n = useI18n();
const locale = useLocale().getLocale();
const utils = useUtils();

const searchText = ref('');
const searchFirstLetter = ref('');

const allVendors = useState('allVendors', () => null);

if (!allVendors.value) {
  allVendors.value = (await useApiFetch(`/api/allVendors?currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).custom.ta.vendors.items;
}

const filteredVendors = ref(allVendors.value);

const search = useDebounceFn(async () => {
  if (searchText.value.length) {
    searchFirstLetter.value = '';
    const searchTextProcessed = utils.removeDiacritics(searchText.value.toLocaleLowerCase().trim());

    filteredVendors.value = allVendors.value.filter(q => utils.removeDiacritics(q.name.toLowerCase()).indexOf(searchTextProcessed) > -1);
  }
  else {
    filteredVendors.value = allVendors.value;
  }
}, 200);

watch(searchText, () => {
  search();
});

const letterToggle = (letter) => {

  if (searchFirstLetter.value === letter) {
    searchFirstLetter.value = '';
    searchText.value = '';
    filteredVendors.value = allVendors.value;
    return;
  }

  searchFirstLetter.value = letter;
  searchText.value = '';
  filteredVendors.value = allVendors.value.filter(q => q.name.toLowerCase().indexOf(letter.toLowerCase()) === 0);
}

</script>
<style lang="postcss">
.all-vendors {
  @apply mb-12;

  &__letter {
    @apply aspect-square w-7 mr-1.5 mb-1 text-center uppercase border border-neutral-200 transition-all duration-300;

    &--selected {
      @apply text-neutral-50 bg-secondary-500 border-secondary-500;
    }
  }
}
</style>
